import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=3f488843"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports